(function Loader($, HE) {
	"use strict";

	// Move these variables outside the function to avoid recreating them on each call
	const texts = [
		$('.loader-text').text(), // Grab initial value from .loader-text
		"Great things take time.",
		"Our suppliers are working for you.",
		"Their best offers are almost here.",
	];

	const subtexts = [
		"We're checking the inventory in the area", // Corresponding subtext for the initial value
		"We're reaching out to hundreds of hotel properties and suppliers.",
		"We're giving them time to come back with their absolute best rates.",
		"This may take a few seconds, but we promise it's worth the wait.",
	];

	const timer = 2500;

	function updateHotelInfo() {
		const $hotels      = $('.random-hotels');
		const $randomHotel = $hotels.eq(Math.floor(Math.random() * $hotels.length));
		const imageUrl     = $randomHotel.data('image');
		const rating       = Math.round($randomHotel.data('rating'));
		const ratingHtml   = '<i class="fa fa-star" aria-hidden="true"></i>'.repeat(rating);
		const img          = new Image();
		img.onload   = function _onload() {
			$('.current-pic').attr('src', imageUrl);
			$('.hotel-name').html('<h4>' + $randomHotel.data('name') + '</h4>' + ratingHtml);
			$('.hotel-address').text($randomHotel.data('address'));
		};
		img.onerror = updateHotelInfo; // Try next random hotel if image fails to load
		img.src = imageUrl;
	}

	function updateProgressBar() {
		let progress   = 5;
		const interval = setInterval(() => {
			progress += 5;
			$('.progress-bar').css('width', `${progress}%`).attr('aria-valuenow', progress);
			if (progress >= 100) {
				clearInterval(interval);
			}
		}, timer);
	}

	function updateLoaderText() {
		const randomIndex = Math.floor(Math.random() * texts.length);
		const randomText = texts[randomIndex];
		let randomSubtext;

		// Ensure the specific subtext is shown with the initial text
		if (randomIndex === 0) {
			randomSubtext = subtexts[0];
		} else {
			randomSubtext = subtexts[Math.floor(Math.random() * (subtexts.length - 1)) + 1];
		}

		$('.loader-text').text(randomText);
		$('.loader-subtext').html('<small>' + randomSubtext + '</small>');
	}

	$(() => {
		HE.onload(['/Hotels/loader', '/Hotels/loading'], () => {
			updateHotelInfo();
			updateProgressBar();
			updateLoaderText();

			setInterval(updateHotelInfo, timer);
			setInterval(updateLoaderText, 6500);

			HE.Ajax.post('/Hotels/getProviderData/searchResults')
			.then(function _afterPost(data) {
				console.log(data); 
				if (data.status && data.status === true) {
					window.location.replace(HE.base_uri + '/Hotels/searchResults');
				} else {
					HE.StatusMessage('error', 'There was an error loading the hotels. Please try again.');
				}
			});
		});
	});
}(jQuery, window.HE || {}));